module.exports = __webpack_public_path__ + "static/img/20009 (4).e76eac6.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20009 (4).webp
// module id = dq1c
// module chunks = 14